import { TabStyles } from '@tableau/widgets';

import { CommonErrorCode, UserErrorCode } from '~commonInfra/utils/ErrorCodes';
import { Set } from '~commonInfra/utils/Set';

import { Formatters, Messages } from '../../codegen/Localize';
import {
  ActionHelpers,   standardActionErrorMsg,
standardActionSuccessMsg
} from '../../commonInfra/contentActions/ActionHelpers';
import {
  IErrorDetail
} from '../../commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { openReactActionDialog } from '../../commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';
import { L10n } from '../../commonInfra/L10n/L10n';
import { DataAlerts } from '../../dda/resources/DataAlerts';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { getSessionManagementServiceInstance } from '../../sessionManagement/SessionManagementService';
import { ServerUsers } from '../../userManagement/services/resources/ServerUsers';
import { IUserInfo } from '../../userManagement/users/models/IUserInfo';
import { IUserActionResult } from '../../userManagement/users/serverApi/types/IUserActionResult';
import { IUserSettings } from '../../userSettings/models/IUserSettings';
import { DdaReactAlertDialog, ReactAlertStringBody, ReactAlertStringBodyProps} from '../components/ReactAlertDialog';
import { IDataAlertInfo } from '../models/IDataAlertInfo';


function  addSelfToAlert(alerts: Set<IDataAlertInfo>): Promise<any> {

    const self = getSessionManagementServiceInstance().sessionUserInfo();

    function getUserEmailAddress(self: IUserInfo): Promise<string> {
        return Promise.resolve(ServerUsers.instance.getUserSettings(self.username, self.domainName)
            .then((userSettings: IUserSettings) => userSettings && userSettings.email));
    }

    function showConfirmDialog(alerts: Set<IDataAlertInfo>, self: IUserInfo) {

      let dialogBodyText: string;
      let dialogTitle: string;
      if (alerts.size() === 1) {
        dialogTitle = Messages.confirmAddSelfToAlertTitle();
        dialogBodyText = Messages.confirmAddSelfToAlert({
          ALERT_NAME: L10n.elideIfLong(alerts.first().name)
        });
      } else {
        dialogTitle = Messages.confirmAddSelfToAlertsTitle();
        dialogBodyText = Messages.confirmAddSelfToAlerts({
          ALERT_COUNT: alerts.size(),
          ALERT_COUNT_LOC: Formatters.formatCount(alerts.size())
        });
      }

      // TODO: This could be converted to ReactConfirmationDialog
      const dialogInstance = openReactActionDialog<ReactAlertStringBodyProps, any, IUserActionResult>({
        title: null,
        dialogBodyStyle : {
          paddingTop: TabStyles.Spacing.LargeSpace,
          paddingBottom: TabStyles.Spacing.LargeSpace},
        bodyComponent: ReactAlertStringBody,
        initialBodyProps: {
          title: dialogTitle,
          message: dialogBodyText
        },
        initialDialogState: {},
        actionName: Messages.confirmAddSelfButton(),
        action: () => DataAlerts.addUsers({ dataAlertIds: alerts.keys(), userIds: [ self.id ] }),
        isActionDelete: false,
        dialogWidth: TabDialogWidth.width500px,
        dismissDialogOnActionFailed: true,
      });

      dialogInstance.result.then((result: IUserActionResult) => {
        notifyResult(alerts, result);
      });

      return dialogInstance.result;
    }

    function showErrorDialogMissingEmail(alerts: Set<IDataAlertInfo>) {
      const title = Messages.errorDataAlertCannotAddTitle(
            { ITEM_COUNT: alerts.size() });
      const message = Messages.errorDataAlertNoEmailAddress();
      return DdaReactAlertDialog.openAlertDialog({title: title, message: message}).result;
    }

    function notifyResult(alerts: Set<IDataAlertInfo>, result: IResult) {
      ActionHelpers.displayStandardToastsForResult(
        alerts,
        result,
        {
          success: standardActionSuccessMsg(Messages.addSelfToAlertsSuccess),
          error: standardActionErrorMsg(Messages.addSelfToAlertsError),
        },
        (errorItem: IErrorItem<IDataAlertInfo>) => errorDetailFor(errorItem)
      );
    }

    function errorDetailFor(errorItem: IErrorItem<IDataAlertInfo>): IErrorDetail {
      const itemName = errorItem.item.name;
      let errorMessage: string;

      switch (errorItem.error.code) {
        case CommonErrorCode.DataAlertNotFound:
          errorMessage = Messages.errorDataAlertNotFound({ ALERT_NAME: L10n.elideIfLong(itemName) });
          break;
        case CommonErrorCode.CallingUserInsufficientPermissions:
          errorMessage = Messages.errorDataAlertNoPermission({ ALERT_NAME: L10n.elideIfLong(itemName) });
          break;
        case UserErrorCode.UserInvalidEmailAddress:
          errorMessage = Messages.errorDataAlertNoEmailAddress();
          break;
        default:
          errorMessage = Messages.errorUnknown();
      }

      return { itemName, errorMessage };
    }

    return getUserEmailAddress(self).then((emailAddress: string) => {
      if (emailAddress) {
        return showConfirmDialog(alerts, self);
      } else {
        return showErrorDialogMissingEmail(alerts);
      }
    });
}

export const AddSelfToAlertsAction = {
    addSelfToAlert,
  };
